import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';

import { createSignlaRHubConnection } from '../actions/messagingActions';
import { IState } from '../reducers';

let startPromise: Promise<void> | null = null;

export const ensureSignalRConnection = async (
    dispatch: ThunkDispatch<IState, any, AnyAction>,
    signalRUri: string,
    token: string
): Promise<HubConnection | undefined> => {
    if (!signalRUri || !token) {
        return undefined;
    }

    const connection = await Promise.resolve(
        dispatch(createSignlaRHubConnection(signalRUri, token))
    ) as HubConnection | undefined;

    if (!connection) {
        return undefined;
    }

    if (connection.state === HubConnectionState.Connected || connection.state === HubConnectionState.Reconnecting) {
        return connection;
    }

    if (connection.state === HubConnectionState.Connecting && startPromise) {
        await startPromise;
        return connection;
    }

    if (connection.state === HubConnectionState.Disconnecting) {
        if (startPromise) {
            await startPromise;
            return connection;
        }
        return connection;
    }

    if (!startPromise) {
        startPromise = connection.start();
    }

    try {
        await startPromise;
    } finally {
        startPromise = null;
    }

    return connection;
};
